/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */
export default class OrderedPageSelectorObserver {
  config = { childList: true, attributes: true, subtree: true };

  watch = true;

  updateSelected(hiddenNode) {
    if (!hiddenNode.value) {
      return;
    }

    this.watch = false;
    const selected = JSON.parse(hiddenNode.value);
    const items = document.querySelectorAll('.ktc-multi-page-box li');
    items.forEach((v, i) => {
      const selectedItem = selected.find((t) => v.title === t.nodeAliasPath);
      selectedItem.order = i;
    });
    hiddenNode.value = JSON.stringify(selected);
  }

  callback(mutationsList, _observer) {
    for (const mutation of mutationsList) {
      if (!window.OrderedPageSelectorObserver.watch) {
        window.OrderedPageSelectorObserver.watch = true;
        break;
      }

      if (mutation.type === 'attributes' && mutation.target) {
        if (
          mutation.target.nodeName === 'INPUT' ||
          mutation.target.nodeName === 'KENTICO-PAGE-SELECTOR-FORM-COMPONENT'
        ) {
          let items = document.querySelectorAll('.ktc-multi-page-box li');
          let current = null;
          const hiddenSelectedNode =
            mutation.target.nodeName === 'INPUT'
              ? mutation.target
              : mutation.target.querySelector('input[type="hidden"]');

          items.forEach((item) => {
            item.draggable = true;
            item.ondragstart = (e) => {
              current = item;
              item.classList.add('active');
            };
            item.ondropenter = (e) => {
              e.preventDefault();
              item.classList.add('over');
            };
            item.ondragover = (e) => {
              e.preventDefault();
              item.classList.add('over');
            };
            item.ondragleave = (e) => {
              item.classList.remove('over');
            };
            item.ondragend = (e) => {
              item.classList.remove('active');
              items.forEach((i) => {
                i.classList.remove('over');
              });
            };
            item.ondrop = (e) => {
              e.preventDefault();
              if (item !== current) {
                let currentPosition = 0;
                let droppedPosition = 0;
                for (let it = 0; it < items.length; it += 1) {
                  if (current === items[it]) {
                    currentPosition = it;
                  }
                  if (item === items[it]) {
                    droppedPosition = it;
                  }
                }
                if (currentPosition < droppedPosition) {
                  item.parentNode.insertBefore(current, item.nextSibling);
                } else {
                  item.parentNode.insertBefore(current, item);
                }
              }
              item.classList.remove('active');
              items.forEach((i) => {
                i.classList.remove('over');
              });
              items = document.querySelectorAll('.ktc-multi-page-box li');
              window.OrderedPageSelectorObserver.updateSelected(hiddenSelectedNode);
            };
          });
          window.OrderedPageSelectorObserver.updateSelected(hiddenSelectedNode);
        }
      }
    }
  }

  getObserver(selector) {
    const targetNode = document.querySelector(selector);
    const observer = new MutationObserver(this.callback);
    observer.observe(targetNode, this.config);
    return observer;
  }
}
